import React from "react";
import { HotTable } from "@handsontable/react";
import "handsontable/dist/handsontable.full.css";
import { useSelector } from "react-redux";
import '../css/HandsonTableCustom.css'
function ServiceDataTable() {
  //const [rows, updateRowData] = useState(data());
  const rows = useSelector((state) => state.dataLoadReducer.data);
  console.log(rows);
  const columns = ["Service Name", "IP","Port", "Description", "Category", "ENV"];

  const tableSettings = {
    colHeaders: columns,
    rowHeaders: true,
    licenseKey: "non-commercial-and-evaluation",
    columnSorting: true,
    manualColumnMove: true,
    manualColumnResize: true,
    filters: true,
    dropdownMenu: true,
    // width:'66vw',
    width: "900px",
   // height: "500px",
    overflow: "hidden",
   
    contextMenu: {
      items: {
        row_above: {
          name: "Insert row above this one",
        },
        row_below: {},

        clear_custom: {
          name: "Clear all cells",
          callback: function () {
            this.clear();
          },
        },
      },
    },
    afterChange: function (change, source) {
      console.log(source);
      if (change != null)
        console.log(
          "row=" +
            change[0][0] +
            " col=" +
            change[0][1] +
            " oldval=" +
            change[0][2] +
            " newVal=" +
            change[0][3]
        );
    },
  }; 

  return (
    <div id="hot-app">
      <HotTable data={rows} settings={tableSettings} />
    </div>
  );
}

export default ServiceDataTable;
